import { Reducer, Action } from 'redux'
import { ICarrierCapacityState } from 'types/carrier'
import {
  CAPACITY_ACTION_TYPES,
  CAPACITY_DIALOG,
  CAPACITY_UPDATE_ACTION_TYPES,
} from 'apps/carrier/utils/actions/capacity'
import { ICarrierCapacity } from 'apps/marketplace/store/contractLanes/types'

const { CAPACITY_FAILURE, CAPACITY_REQUEST, CAPACITY_SUCCESS } = CAPACITY_ACTION_TYPES
const { CAPACITY_DIALOG_CLOSE, CAPACITY_DIALOG_OPEN } = CAPACITY_DIALOG
const {
  CAPACITY_UPDATE_FAILURE,
  CAPACITY_UPDATE_REQUEST,
  CAPACITY_UPDATE_SUCCESS,
} = CAPACITY_UPDATE_ACTION_TYPES

const defaultState: ICarrierCapacityState = {
  capacities: [],
  loading: false,
  showDialog: false,
  updating: false,
}

interface SuccessAction extends Action<string> {
  payload: {
    offerLimits: ICarrierCapacity[]
  }
}
interface FailureAction extends Action<string> {
  error: string
}

type carrierCapacityReducerAction = Action<string> | SuccessAction | FailureAction

const carrierCapacityReducer: Reducer<ICarrierCapacityState, carrierCapacityReducerAction> = (
  state = defaultState,
  action
) => {
  if (!action) return state
  switch (action.type) {
    case CAPACITY_REQUEST: {
      return {
        ...state,
        loading: false,
        error: undefined,
      }
    }
    case CAPACITY_SUCCESS: {
      const {
        payload: { offerLimits },
      } = action as SuccessAction
      return {
        ...state,
        capacities: offerLimits,
        loading: false,
      }
    }
    case CAPACITY_FAILURE: {
      const { error } = action as FailureAction
      return {
        ...state,
        loading: false,
        error,
      }
    }
    case CAPACITY_UPDATE_REQUEST: {
      return {
        ...state,
        updating: true,
      }
    }
    case CAPACITY_UPDATE_SUCCESS: {
      const {
        payload: { offerLimits },
      } = action as SuccessAction
      return {
        ...state,
        capacities: offerLimits,
        updating: false,
        errors: undefined,
        showDialog: false,
      }
    }
    case CAPACITY_UPDATE_FAILURE: {
      const { error } = action as FailureAction
      return {
        ...state,
        updating: false,
        updateError: error,
      }
    }
    case CAPACITY_DIALOG_OPEN: {
      return {
        ...state,
        showDialog: true,
        updateError: undefined,
      }
    }
    case CAPACITY_DIALOG_CLOSE: {
      return {
        ...state,
        showDialog: false,
      }
    }
    default:
      return state
  }
}

export default carrierCapacityReducer
